import {RegionBean} from 'common/api/api'
import {dictionaryApi} from 'common/api/entitiesApi'
import {LabelValue, ReloadableSelector} from 'common/components/reloadable/ReloadableSelector'
import React, {FC} from 'react'

interface Props {
    onChange: (value: number[]) => void
    value?: number[]
    style?: React.CSSProperties
    disabled?: boolean
    placeholder?: string
}

export const RegionSelector: FC<Props> = ({value, onChange, style, disabled, placeholder}: Props) => {
    function regionToLabelValue(region: RegionBean) {
        const name = region.countryName + " / " + region.name
        return {value: region.id, label: name} as LabelValue<number>
    }

    function loadRegions(values: number[]) {
        if (values && values.length > 0) {
            return dictionaryApi.regionGet(values).then(result => result.map(regionToLabelValue))
        } else {
            return Promise.resolve([])
        }
    }

    function searchRegions(search: string, selectedValues: number[], size: number, page: number) {
        return dictionaryApi.regionSearch(search, size, page, selectedValues).then(result => result.map(regionToLabelValue))
    }

    return <ReloadableSelector
        value={value}
        onChange={onChange}
        size={100}
        style={style}
        loadValues={loadRegions}
        loadOptions={searchRegions}
        placeholder={placeholder}
        disabled={disabled}
        errorText="Can't load regions"
        multiple
    />
}